"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchStatus = exports.ValueNodeReturnType = exports.DynamicValueType = exports.ErrorMode = exports.TrackingMode = exports.NodeType = void 0;
var NodeType;
(function (NodeType) {
    NodeType["Allowlist"] = "allowlist";
    NodeType["Blacklist"] = "blacklist";
    NodeType["Denylist"] = "denylist";
    NodeType["Meta"] = "meta";
    NodeType["Multivariate"] = "multivariate";
    NodeType["Percentage"] = "percentage";
    NodeType["Value"] = "value";
    NodeType["Whitelist"] = "whitelist";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var TrackingMode;
(function (TrackingMode) {
    TrackingMode["Debug"] = "debug";
    TrackingMode["Experiment"] = "experiment";
    TrackingMode["Silent"] = "silent";
})(TrackingMode = exports.TrackingMode || (exports.TrackingMode = {}));
var ErrorMode;
(function (ErrorMode) {
    ErrorMode["LogAll"] = "log_all";
    ErrorMode["Reduced"] = "reduced";
    ErrorMode["Silent"] = "silent";
})(ErrorMode = exports.ErrorMode || (exports.ErrorMode = {}));
var DynamicValueType;
(function (DynamicValueType) {
    DynamicValueType["Experiment"] = "experiment";
    DynamicValueType["Rollout"] = "rollout";
    DynamicValueType["Operational"] = "operational";
    DynamicValueType["Custom"] = "custom";
})(DynamicValueType = exports.DynamicValueType || (exports.DynamicValueType = {}));
var ValueNodeReturnType;
(function (ValueNodeReturnType) {
    ValueNodeReturnType["Boolean"] = "boolean";
    ValueNodeReturnType["Float"] = "float";
    ValueNodeReturnType["Int"] = "int";
    ValueNodeReturnType["Json"] = "json";
    ValueNodeReturnType["String"] = "string";
})(ValueNodeReturnType = exports.ValueNodeReturnType || (exports.ValueNodeReturnType = {}));
var MatchStatus;
(function (MatchStatus) {
    MatchStatus["SUCCESS"] = "MATCH_STATUS_SUCCESS";
    MatchStatus["FAILURE"] = "MATCH_STATUS_FAILURE";
    MatchStatus["ERROR"] = "MATCH_STATUS_ERROR";
})(MatchStatus = exports.MatchStatus || (exports.MatchStatus = {}));
//# sourceMappingURL=types.js.map